import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_500: DocMigration = {
  maxSchemaVersion: "0.0.500",
  description: "Migrate aux option sets to option sets, drop aux option sets table from doc",
  apply(json: any): any {
    for (const id in json.auxOptionSets) {
      if (!id || id === "undefined") {
        continue;
      }

      const auxOptionSet = json.auxOptionSets[id];

      if (!auxOptionSet) {
        continue;
      }

      const optionSet = json.optionSets[id];

      if (!optionSet) {
        continue;
      }

      const entityRef = json.entityRefs[id];

      /**
       * Previously, AUX_OPTION_SET entity refs were being processed after their corresponding OPTION_SET entity refs,
       * Because the aux option set had the same id, the option set entity ref was being overridden. In order to preserve
       * the correct entity ref behavior, we need to reset the entity type back to the correct OPTION_SET entity type.
       */
      if (entityRef?.entityType === "AUX_OPTION_SET") {
        entityRef.entityType = "OPTION_SET";
      }

      if (optionSet.optionSetType !== "USER") {
        console.warn(`Non user option set of type ${optionSet.optionSetType} referenced by aux option set`);
        continue;
      }

      if (auxOptionSet.ineligibleHotspotEntities) {
        optionSet.ineligibleHotspotEntities = auxOptionSet.ineligibleHotspotEntities;
      }

      if (auxOptionSet.includeOptionOnMasterPlanSet) {
        optionSet.includeOptionOnMasterPlanSet = auxOptionSet.includeOptionOnMasterPlanSet;
      }
    }

    // Remove auxOptionSets from doc
    delete json.auxOptionSets;

    return json;
  },
};

export default migration_0_0_500;
